import Vue from "vue";

function splitIntoRegex(string) {
    if (string) {
        string = string.replace(/\s?$/, '');
        string = string.replaceAll(' ', '|')
        var regex = new RegExp('(' + string + ')', 'gi');
        return regex
    }
    else {
        return string
    }
}

Vue.filter("searchhighlight", function (input, searchword, regexed) {
    if (!regexed) {
        var regex = regexed ? searchword : splitIntoRegex(searchword)
        console.log('new regex', regex)
    }
    if (input && searchword) {
        return ('' + input).replace(searchword, '<b style="/*color: var(--v-tertiary-base) !important;*/ background-color: #feb5ff !important;">' + searchword + '</b>')
    }
    else {
        return input
    }
});

export default {
    data() {
        return {
            dateSeparator: "->",
            maxChipTextLength: 10,
        };
    },
    methods: {

        searchhighlight(input, searchword, regexed) {
            return this.$options.filters.searchhighlight(input, searchword, regexed)
        },

        reclaimChips(queryKey) {
            if (this.$route.query[queryKey]) {
                return this.$route.query[queryKey].split(",");
            }
            return [];
        },

        reclaimDates(queryKey) {
            if (this.$route.query[queryKey]) {
                //console.log(this.$route.query[queryKey])
                return this.$route.query[queryKey].split(this.dateSeparator);
            }
            return [];
        },

        chipFilterFiller(objectkey, objectArray) {
            var output = [];
            if (objectArray != undefined) {
                for (let i = 0; i < objectArray.length; i++) {
                    if (objectArray[i][objectkey] !== (null || undefined)) {
                        output.push(objectArray[i]);
                    } else {
                        continue;
                    }
                }
            }
            return output;
        },

        chipArrayToString(chipArray) {
            var chipsAsString = undefined;
            if (chipArray != null) {
                if (chipArray.length > 0) {
                    for (let i = 0; i < chipArray.length; i++) {
                        if (i === 0) {
                            chipsAsString = chipArray[i];
                        } else {
                            chipsAsString += "," + chipArray[i];
                        }
                    }
                }
            }
            return chipsAsString;
        },
        /*
            chipTextTrim(string) {
                if (string.length > this.maxChipTextLength) {
                    string = string.substring(0, (this.maxChipTextLength - 3)) + "...";
                }
                return string;
            },
        */
        dateArrayToString(dateArray) {
            if (dateArray[0]) {
                return dateArray[0] + this.dateSeparator + dateArray[1];
            }
            else {
                return undefined;
            }
        },

        applyFilterToURL(queryValue, queryKey) {
            if (queryValue != this.$route.query[queryKey]) {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, this.$route.query, { [queryKey]: queryValue }),
                });
            }
        }
    }
}
